export interface SurveyQuestionModel {
    id: string;
    text: string;
    number: number;
    type: SurveyQuestionType;
    scaleStart: number | null;
    scaleEnd: number | null;
    answers?: any;
}

export enum SurveyQuestionType {
    FreeTextInput,
    RadioSelectNumeric,
    GroupLabel
}